import { useAppContext } from '../../Services/AppContext';
import { useState } from 'react';
import * as React from 'react';
import Search from '../Search/Search';
import { useLazyFilterCaseContactsQuery } from '../../graphql/graphql';
import SearchCaseContactItem from './SearchCaseContactItem';
import { useEffectAsync } from '../../helpers';
import { get } from '../../Services/NetteApiClient';
import SearchCaseContactNoResults from './SearchCaseContactNoResults';

interface Props {
	linkSelect: any;
	patientId: string;
}

const SearchCaseContact: React.FC<Props> = ({ linkSelect, patientId }) => {
	const { translation } = useAppContext();
	const [fulltext, setFulltext] = useState('');
	const [items, setItems] = useState<any>(null);
	const [getCaseContacts] = useLazyFilterCaseContactsQuery();

	const handleSelectItem = async (
		workplaceId?: string,
		workplaceMemberId?: string,
	) => {
		let ajaxLink = linkSelect;

		if (workplaceId) {
			ajaxLink = ajaxLink.replace('=workplaceIdPlaceholder', '=' + workplaceId);
		}
		if (workplaceMemberId) {
			ajaxLink = ajaxLink.replace(
				'=workplaceMemberIdPlaceholder',
				'=' + workplaceMemberId,
			);
		}

		await get(ajaxLink);
	};

	useEffectAsync(async () => {
		const data = await getCaseContacts({
			fulltext,
		});

		const tempData = data?.data?.filterCaseContacts?.data;

		if (tempData?.length) {
			setItems(
				tempData?.map((item: any, index: number) => (
					<React.Fragment key={index}>
						<SearchCaseContactItem
							item={item}
							onClick={handleSelectItem}
							patientId={patientId}
						/>
					</React.Fragment>
				)),
			);
		} else {
			setItems(<SearchCaseContactNoResults />);
		}
	}, [fulltext]);

	return (
		<Search
			resultContent={items !== null ? items : null}
			handleSearch={(text: string) => setFulltext(text)}
			placeholder={translation['base.startTyping']}
		/>
	);
};

export default SearchCaseContact;
